import { INSTRUMENT_DISPLAY_LOCATION_OPTIONS, INSTRUMENT_TYPE_MAP } from 'utils/constants'

/** Participant-only schedule fields that clinician instruments do not use. */
const HIDDEN_TIMEOUT_KEYS = ['review', 'edit', 'draft', 'submission']

const CAROUSEL_ONLY = [INSTRUMENT_DISPLAY_LOCATION_OPTIONS.carousel]

export const isClinroInstrument = instrumentOrType => {
  const type = typeof instrumentOrType === 'string' ? instrumentOrType : instrumentOrType?.type
  return String(type || '').toUpperCase() === INSTRUMENT_TYPE_MAP.clinro
}

const cleanSchedule = schedule => {
  if (!schedule || typeof schedule !== 'object' || Array.isArray(schedule)) return schedule
  const next = { ...schedule }
  delete next.submission_expiry
  if (next.timeout_window && typeof next.timeout_window === 'object') {
    const timeout = { ...next.timeout_window }
    HIDDEN_TIMEOUT_KEYS.forEach(key => {
      delete timeout[key]
    })
    if (Object.keys(timeout).length) next.timeout_window = timeout
    else delete next.timeout_window
  }
  return next
}

/**
 * Drop participant-only values from a clinician instrument save.
 * Display mode is stored as carousel only once the instrument is saved.
 * Call this from save paths. Fetch and drawer reads must keep the stored JSON.
 */
export const omitHiddenClinroParticipantFields = metadata => {
  if (!metadata || typeof metadata !== 'object') return metadata
  const next = { ...metadata }
  next.display_location = CAROUSEL_ONLY
  next.placement = CAROUSEL_ONLY
  delete next.participant_session
  delete next.review_screen
  if (Array.isArray(next.schedule)) next.schedule = next.schedule.map(cleanSchedule)
  else if (next.schedule) next.schedule = cleanSchedule(next.schedule)
  return next
}

export const withoutHiddenClinroParticipantFields = instrument => {
  if (!isClinroInstrument(instrument) || !instrument.metadata) return instrument
  return {
    ...instrument,
    metadata: omitHiddenClinroParticipantFields(instrument.metadata),
  }
}

const collectSchedules = (instrument, extraSchedules) => {
  const metadataSchedule = instrument?.metadata?.schedule
  const fromMetadata = Array.isArray(metadataSchedule)
    ? metadataSchedule
    : metadataSchedule
      ? [metadataSchedule]
      : []
  const extra = Array.isArray(extraSchedules) ? extraSchedules : []
  return [...fromMetadata, ...extra].filter(schedule => schedule && typeof schedule === 'object')
}

/**
 * Old clinician instruments still store these until they are edited and saved.
 * After that save, the drawer hides Review Screen Settings and Save & Resume.
 */
export const hasStoredClinroParticipantProperties = (instrument, extraSchedules) => {
  const metadata = instrument?.metadata
  if (!metadata) return false
  if (metadata.review_screen != null || metadata.participant_session != null) return true
  return collectSchedules(instrument, extraSchedules).some(schedule => {
    if (schedule.submission_expiry != null) return true
    const timeout = schedule.timeout_window
    if (!timeout || typeof timeout !== 'object') return false
    return HIDDEN_TIMEOUT_KEYS.some(key => timeout[key] != null)
  })
}
